module.exports = __webpack_public_path__ + "img/profile-icon.2a8ec90f.svg";